import { FormControl, InputLabel, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";

//NOTE currently only works with options that are an array of strings, further refactoring needed if you need to pass in objects

const ControlledFormAutoComplete = ({
  control,
  defaultValue = "",
  fullWidth = false,
  inputProps,
  label,
  name,
  disabled = false,
  rules = {},
  ...props
}) => {
  const [clickValue, setClickValue] = useState("");
  const [typedValue, setTypedValue] = useState("");
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      rules={rules}
      render={({
        field: { onBlur, onChange, ref, value },
        fieldState: { error },
      }) => (
        <FormControl
          disabled={disabled}
          fullWidth={fullWidth}
          margin="none"
          size="small"
        >
          <InputLabel>{label}</InputLabel>
          <Autocomplete
            inputValue={value === defaultValue ? value : typedValue}
            onBlur={onBlur}
            onInputChange={(event, newValue) => {
              if (newValue === "undefined") return;
              setTypedValue(newValue);
              onChange(newValue);
            }}
            onChange={(event, newValue) => {
              setClickValue(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={Boolean(error)}
                helperText={error?.message}
                name={name}
                InputProps={{
                  ...params.InputProps,
                  ...inputProps,
                }}
                variant="standard"
              />
            )}
            disabled={disabled}
            value={value === defaultValue ? value : clickValue}
            {...props}
          />
        </FormControl>
      )}
    />
  );
};
export { ControlledFormAutoComplete };
